/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { BackgroundPanel, TableAdvanced } from "vr-react-components";
import { getFormattedTime } from "../../../utils/TimeUtils";
import BarPanelAux from "../DesktopRoom/BarPanelAux";

const RightPanelVR = React.memo(({ width, height }) => {
    const innerWidth = (width / 2) * 0.9;
    const innerHeight = height * 0.9;

    const lastTenRunsTable = useSelector((state) => state.jobroom.lastTenRunsTable);
    const canModify = useSelector((state) => state.private.device.canModify);

    return (
        <>
            <BackgroundPanel
                width={width / 2}
                height={height}
                position={`${2.5} 0 ${1.5}`}
                rotation="0 -60 0"
            >
                <BarPanelAux
                    stateName="lastTenRunsChart"
                    width={innerWidth}
                    height={innerHeight / 2 - height * 0.005}
                    panel
                    title="Last 10 runs duration (in min)"
                    backgroundColor="#262626"
                    position={`0 ${+height / 2 - innerHeight * 0.25 - height * 0.05} ${innerWidth / 100
                        }`}
                />
                <BarPanelAux
                    stateName="dataChartDuration"
                    width={innerWidth}
                    height={innerHeight / 2 - height * 0.005}
                    panel
                    position={`0 ${-height / 2 + innerHeight * 0.25 + height * 0.05} ${innerWidth / 100
                        }`}
                    title="Job Duration (by minute range)"
                />
            </BackgroundPanel>
            <BackgroundPanel
                width={width / 2}
                height={height}
                position={`${width / 4} 0 0`}
                rotation={"0 -30 0"}
            >
                <TableAdvanced
                    width={innerWidth}
                    height={innerHeight / 2 - height * 0.005}
                    aframeClasses={canModify ? "collidable" : ""}
                    data={[
                        ["Scheduled date", "Start date", "Duration"],
                        ...(lastTenRunsTable
                            ? lastTenRunsTable.map((x) => {
                                return [
                                    getFormattedTime(x[0]),
                                    getFormattedTime(x[1]) || "Not started",
                                    x[2],
                                ];
                            })
                            : []),
                    ]}
                    position={`0 ${height / 2 - height * 0.05} ${innerWidth / 100}`}
                />
                <BarPanelAux
                    panel
                    stateName="dataChartStartTime"
                    width={innerWidth}
                    height={innerHeight / 2 - height * 0.005}
                    title="Starting time (by time range)"
                    position={`0 ${-height / 2 + innerHeight * 0.25 + height * 0.05} ${innerWidth / 100
                        }`}
                />
            </BackgroundPanel>
        </>
    );
});

export default RightPanelVR